// extracted by mini-css-extract-plugin
export default {"category-tree":"CategoryMediaSelect_category-tree__fYbhN","zr-tree-content-wrapper":"CategoryMediaSelect_zr-tree-content-wrapper__7MNC0"};